import React from 'react';
import { render } from 'react-dom';

// import packages
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';

import './styles/main.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';

// import my components
import Login from './containers/Login';
import Main from './components/Main';
import Alertas from './containers/Alertas';
import Cameras from './containers/Cameras';
import Ajustes from './containers/Ajustes';
import Geolocator from './components/Geolocator';
import Marcadores from './containers/Marcadores';
import Mosaico from './containers/Mosaico';

import store from './store';

import firebase from './util/firebase';

const router = (
  <Provider store={ store }>
    <Geolocator>
      <Router>
        <Switch>
          <Route path="/login" component={ Login } />
          <Route path="/signup" component={ Login } />  
          <Route path="/completar-cadastro" component={ Login } />

          <Main>
            <Route path="/alertas/:filter?" component={ Alertas } />
            <Route path="/cameras-publicas" component={ Cameras } />
            <Route path="/minhas-cameras" component={ Cameras } />
            <Route path="/ajustes" component={ Ajustes } />
            <Route path="/marcadores" component={ Marcadores } />
            <Route path="/mosaico" component={ Mosaico } />
          </Main>

          <Route path="/login" /> {/* criar uma página 404? */}
        </Switch>
      </Router>
    </Geolocator>
  </Provider>
);

firebase.database().ref("whitelabel/").on('value', snapshot => {
  let whiteLabel = snapshot.val();
  if (whiteLabel){
    document.title = whiteLabel.title;
    document.getElementById("favicon").href = whiteLabel.favicon;
    document.body.style.setProperty("--main-color", whiteLabel.mainColor);
    document.body.style.setProperty("--action-color", whiteLabel.actionColor);
    window.whiteLabel = {
      title: whiteLabel.title,
      mainColor: whiteLabel.mainColor,
      actionColor: whiteLabel.actionColor,
      slogan: whiteLabel.slogan,
      logoMain: whiteLabel.logoMain,
      logoBar: whiteLabel.logoBar
    }
  } else {
    window.whiteLabel = {
      title: "Nome do Projeto",
      mainColor: "#FFB6C1",
      actionColor: "#FF69B4",
      slogan: "Defina o slogan, cores e logos no firebase em 'whitelabel'",
      logoMain: "https://firebasestorage.googleapis.com/v0/b/emive-rediseg-48554.appspot.com/o/images%2Fdefault-logo.png?alt=media&token=2e6ad27d-8664-434c-b883-3d06791faa5e",
      logoBar: "https://firebasestorage.googleapis.com/v0/b/emive-rediseg-48554.appspot.com/o/images%2Fdefault-logo.png?alt=media&token=2e6ad27d-8664-434c-b883-3d06791faa5e",
      favicon: "https://firebasestorage.googleapis.com/v0/b/emive-rediseg-48554.appspot.com/o/images%2Fdefault-favicon.png?alt=media&token=1496d175-fa03-4023-ab80-4e299ca95201"
    }
    firebase.database().ref("whitelabel").set(window.whiteLabel);
  }
  render(router, document.querySelector('#root'));
});




// WEBPACK FOOTER //
// ./src/index.js